<template>
  <div class="slider">
    <div
      class="runway"
      ref="runway"
    >
      <div
        class="bar"
        :style="{width: `${currentPosition}%`}"
      ></div>
      <div
        class="handler"
        v-dragged="onDrag"
        :style="{left: `${currentPosition}%`}"
      ></div>
    </div>
  </div>
</template>

<script>
function mid (val, min, max) {
  return Math.min(Math.max(min, val), max);
}

export default {
  props: {
    value: Number,
    totalValue: Number,
    startValue: Number,
    unit: Number,
    originValue: { default: 0 },
    afterDot: {default: 0}
  },
  data () {
    return {
      isDragging: false,
      runwayStart: 0,
      runwayLength: 0,
    };
  },
  computed: {
    currentPosition () {
      let pos = (this.value - this.startValue) / this.totalValue * 100;
      return mid(pos, 1, 100);
    }
  },
  mounted () {
    this.initRunway();
  },
  methods: {
    onDrag ({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
      if (first) {
        this.isDragging = true;
        this.initRunway();
        this.$emit('updateValue', this.value, 'first');
        return;
      }
      if (last) {
        this.isDragging = false;
        this.$emit('updateValue', this.value, 'last');
        return;
      }

      this.onDragMove({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY });
    },
    onDragMove ({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY }) {
      let position = this.getMovingPosition(clientX);
      this.setValueByPosition(position);
      this.$emit('updateValue', this.value);
    },
    getMovingPosition (clientX) {
        return (clientX - this.runwayStart) / this.runwayLength * 100;
    },
    setValueByPosition (position) {
        position = mid(position, 0, 100);
        let stepTotal = this.totalValue / this.unit;
        let lengthPerStep = 100 / stepTotal;
        let steps = Math.round(position / lengthPerStep);
        let val = this.totalValue / 100 * lengthPerStep * steps + this.startValue;
        val = val.toFixed(this.afterDot) - 0;
        this.$emit('input', val);
    },
    initRunway () {
      let el = this.$refs.runway;
      let rect = el.getBoundingClientRect();
      this.runwayStart = rect.left;
      this.runwayLength = rect.width;
    },
  }
}
</script>

<style lang="scss" scoped>
.runway {
  position: relative;
  width: 134px;
  height: 4px;
  background-color: #d9ddea;
  border-radius: 4px;
}
.bar {
  height: 4px;
  background-color: #737596;
  border-radius: 4px;
}
.handler {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: -4px;
  margin-left: -6px;
  width: 12px;
  height: 12px;
  background-color: #737596;
  border-radius: 50%;
  cursor: grab;
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/slider.vue